module.exports = __webpack_public_path__ + "img/miniprogram_wechat.5ef0e80b.png";